import { $ } from 'hanako-ts/dist/Framework';
import { Collection } from 'hanako-ts/dist/Collection';
import { Component } from 'hanako-ts/dist/Component';
import { Pixelator } from '../../components/PageAppear/Appearers/Pixelator';

export class Page404 extends Component {

  constructor() {
    super('Page404', true);
  }

  public async init(): Promise<void> {
    await super.init();

    $('.error404 img').each((img: Collection) => {
      const imageLoader = new Image();
      imageLoader.src = img.data('src');
      imageLoader.onload = () => {
        img.attr('src', img.data('src'));

        const resolution = $(window).width() > 768 ? 32 : 8;
        new Pixelator(img.get(0), () => { }, resolution, true);
      };

    });

    this.success();
  }
}
